import * as React from "react";
import { forwardRef } from "react";
const SvgOmniEdit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.1186 9.02L15.0386 9.94L5.97859 19H5.05859V18.08L14.1186 9.02ZM17.7186 3C17.4686 3 17.2086 3.1 17.0186 3.29L15.1886 5.12L18.9386 8.87L20.7686 7.04C21.1586 6.65 21.1586 6.02 20.7686 5.63L18.4286 3.29C18.2286 3.09 17.9786 3 17.7186 3ZM14.1186 6.19L3.05859 17.25V21H6.80859L17.8686 9.94L14.1186 6.19Z", fill: "#7D7D7D" }));
const ForwardRef = forwardRef(SvgOmniEdit);
export { ForwardRef as ReactComponent };
